import { AlignTypes } from "@monorepo-web/components-library";
export const getLayouts = (moneyPrefix) => ({
    'default': [
        {
            id: 'classe',
            label: 'Classe',
            orderBy: 'classe',
            colorLegend: true,
            freeze: true,
        },
        {
            id: 'saldo',
            label: 'Saldo Bruto',
            align: AlignTypes.right,
        },
        {
            id: 'percent',
            label: '%',
            align: AlignTypes.right,
        },
        {
            id: 'mes',
            label: 'No Mês',
            align: AlignTypes.right,
        },
        {
            id: 'ano',
            label: 'No Ano',
            align: AlignTypes.right,
        },
    ],
    'percent': [
        {
            id: 'classe',
            label: 'Classe',
            orderBy: 'classe',
            colorLegend: true,
            freeze: true,
        },
        {
            id: 'percent',
            label: '%',
            align: AlignTypes.right,
        },
        {
            id: 'saldo',
            label: 'Saldo Bruto',
            align: AlignTypes.right,
        },
        {
            id: 'mes',
            label: `No Mês (${moneyPrefix})`,
            align: AlignTypes.right,
        },
        {
            id: 'ano',
            label: `No Ano (${moneyPrefix})`,
            align: AlignTypes.right,
        },
        {
            id: 'mesPerf',
            label: 'No Mês (%)',
            align: AlignTypes.right,
        },
        {
            id: 'anoPerf',
            label: 'No Ano (%)',
            align: AlignTypes.right,
        },
    ]
});
